<template>
  <div class="login-wrapper" :style="getStyle">
    <template v-if="validateTokenAndKey">
      <div class="app-down" v-if="appId"><div class="app-down-content" @click="doDown">APP下载</div></div>
      <div class="app-external-link" v-if="tenantId === '1696BDBF-CC00-09CF-B406-9198CC9854E2'">
        <a class="app-down-content" href="http://www.che-henry.cn/huaaohz" target="_blank">合作商查询平台</a>
      </div>
      <!--登录框-->
      <login-component
        v-show="loginShow"
        :allowLoginType="loginType"
        :applicationName="page.applicationName"
        :isMobile="isMobile"
        @openMessage="openMessage"
      ></login-component>
      <div class="login-box login-error" v-show="errorShow">
        网络异常，请稍后 <a href="/">重试</a>
      </div>
      <div v-if="browserVersionFlag" class="versionMask">
        <div class="box">
          <div class="box-title">
            <div>{{page.applicationName}}</div>
          </div>
          <div class="prompt">
            <div class="text">
              <div><i class="el-icon-warning"></i></div>
              <div class="updateBrowser">
                您正在使用的浏览器内核版本过低，
                <a href="https://www.microsoft.com/zh-cn/WindowsForBusiness/End-of-IE-support" target="_blank" v-if="isIE()">
                  微软已经不再提供技术支持，</a>
                为避免可能存在的安全隐患，请尽快升级您的浏览器或者安装更安全的浏览器登录{{page.applicationName}}。
              </div>
            </div>
            <div class="recommended-download">推荐下载：</div>
            <div class="updateBrowserList">
              <a href="https://www.google.cn/chrome/" target="_blank" class="chromeBrowser">
                <img  alt="chrome" src="./assets/chrome.png">
                <span>Chrome</span>
              </a>
              <a href="https://ie.sogou.com/" target="_blank" class="souhuBrowser">
                <img  alt="搜狗浏览器" src="./assets/sogou.png">
                <span>搜狗浏览器</span>
              </a>
              <a href="https://browser.qq.com/" target="_blank" class="qqBrowser">
                <img  alt="QQ浏览器" src="./assets/qqbrower.png">
                <span>QQ浏览器</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import CookieOperation from '@/plugins/cookie'
import loginComponent from './login-component.vue'
import { applicationSettings } from '@/store/app-common-data/applicationSetting'
export default {
  name: 'login',
  components: {
    loginComponent
  },
  data () {
    return {
      page: {
        applicationName: '红猫系统设计平台',
        backgrounds: ''
      },
      tenantId: '',
      appId: '',
      loginType: '',
      loginShow: false,
      errorShow: false,
      messageBox: {
        message: '',
        visiable: false
      },
      browserVersionFlag: this.browserCheck(),
      validateTokenAndKey: false,
      isMobile: false
    }
  },
  created () {
    // 如果当前环境为 dev
    if (process.env.NODE_ENV === 'development') {
      CookieOperation.set('domain', this.getDomain(process.env.PROXY_PATH) || '2405.rc-dev-test.ywsoftware.cn')
    }
    // 校验 accessToken 和 accessKey
    let params = {
      token: this.getTokenOrKey('accessToken'),
      key: this.getTokenOrKey('accessKey')
    }
    let from = this.getTokenOrKey('from')
    let titleName = this.getTokenOrKey('applicationName')
    if (from === 'qywx') {
      let token = this.getTokenOrKey('token')
      // 企业微信在pc打开就直接登录
      document.title = titleName || '红猫系统测试平台'
      sessionStorage.setItem('token', `bearer ${token}`)
      let data = this.getTokenOrKey('data')
      if (data) {
        data = JSON.parse(window.atob(decodeURIComponent(data)))
        this.$router.push({ name: 'index', query: { type: data.type, taskId: data.taskId, isFromQYWXNotice: true, token: token } })
      } else {
        this.$router.push({ name: 'index', query: { token: token } })
      }
    } else if (params.token && params.key) {
      axios.get('/auth-api/login/no-auth/validateKey', { params }).then(res => {
        // 为啥要用两个呢。
        sessionStorage.setItem('token', `bearer ${params.token}`)
        localStorage.setItem('token', `bearer ${params.token}`)
        CookieOperation.set('tenantId', this.getTokenOrKey('tenantId'))
        // 如果有，不管他是什么域名下的，先删除
        if (CookieOperation.get('securityPw')) {
          CookieOperation.remove('securityPw')
        }
        CookieOperation.set('securityPw', true)
        this.$router.push({ name: 'index', query: { token: params.token } })
        document.title = `测试-${titleName || '红猫系统测试平台'}`
        CookieOperation.set('isTest', true)
      }).catch(res => {
        this.validateTokenAndKey = true
      })
    } else {
      this.validateTokenAndKey = true
    }
  },
  mounted () {
    window.localStorage.removeItem('token')
    // 根据域名获取应用名、图标等
    this.getApplicationSettings().then(() => {
      // 获取appid
      this.getApplicationIdByTenantId()
    })
    window.onresize = this.$_.debounce(() => this.isMobileBrowser())
  },
  methods: {
    getApplicationSettings () {
      // 根据域名获取应用名、图标等
      // XXX：按需求调整获取租户信息失败后返回空白页面。如果本地开发不便，用 cookie 设置域名。
      let domain = document.domain
      if (process.env.NODE_ENV === 'development') {
        domain = CookieOperation.get('domain') || console.warn('本地开发设置 cookie.domain') || '8854.rc-dev-test.ywsoftware.cn'
      }
      return axios.get('/system-api/application/getSettingByDomain', { params: { domain }, timeout: 30000, disableInterceptors: true })
        .then((res) => {
          let data = res.data
          if (!(data && data.data)) {
            return Promise.reject(new Error('获取租户信息失败'))
          }
          this.loginShow = true
          this.page.applicationName = data.data.applicationName
          CookieOperation.set('tenantId', data.data.id)
          this.isMobileBrowser()
          localStorage.setItem('tenantInfo', JSON.stringify(data.data))
          document.title = data.data.applicationName || '红猫系统设计平台'
          switch (data.data.pcLoginModel) {
            case 'qrcode':
              this.loginType = 'codeLogin'
              break
            case 'both':
              this.loginType = 'both'
              break
            default:
              this.loginType = 'accountLogin'
          }
          this.tenantId = CookieOperation.get('tenantId')

          let link = document.querySelector("link[rel*='icon']")
          if (link) {
            link.type = 'image/x-icon'
            link.rel = 'shortcut icon'
            if (this.tenantId === '1696BDBF-CC00-09CF-B406-9198CC9854E2') {
              link.href = '../../static/favicon1.ico'
            } else {
              link.href = '../../static/favicon.ico'
            }
          }
          this.page.backgrounds = res.data.data && res.data.data.backgrounds ? res.data.data.backgrounds : require('./assets/newTenant.png')
          // 第一次请求的时候就要拿到一些常用的默认数据，全局存储
          this.getSomeApplicationData(res.data.data)
        })
        .catch(() => {
          document.title = '红猫系统设计平台'
          this.errorShow = true
          this.openMessage('获取登录方式失败, 已被重置成用户登录方式, 请联系管理员.')
        })
    },
    getApplicationIdByTenantId () {
      axios.get(`/mobile-api/design/no-auth/getApplicationIdByTenantId/${this.tenantId}`, { disableInterceptors: true })
        .then((res) => {
          this.appId = res.data
        })
    },
    getSomeApplicationData (data) {
      // 主题
      applicationSettings.themeColor = data.themeColor
      // 水印
      applicationSettings.waterMarkEnable = data.waterMarkEnable
    },
    doDown () {
      window.open(location.origin + '/app', '_blank')
    },
    openMessage (tip) {
      this.messageBox.visiable = true
      this.messageBox.message = tip
      setTimeout(() => {
        this.messageBox.visiable = false
      }, 2000)
    },
    //  浏览器检测
    browserCheck () {
      // 取得浏览器的userAgent字符串
      const userAgent = navigator.userAgent.toLowerCase()
      let browserVersionFlag = false
      if (this.isPC()) {
        if (/windows|win32/i.test(userAgent)) {
          if (userAgent.indexOf('firefox') > 0 && Number(userAgent.match(/firefox\/([\d.]+)/)[1].split('.')[0]) < 58) {
            browserVersionFlag = true
          } else if (this.isIE()) {
            browserVersionFlag = true
          }
        } else if (/macintosh|mac os x/i.test(userAgent)) {
          if (userAgent.indexOf('firefox') > 0 && Number(userAgent.match(/firefox\/([\d.]+)/)[1].split('.')[0]) < 58) {
            browserVersionFlag = true
          } else if (userAgent.indexOf('safari') > 0 && userAgent.indexOf('chrome') === -1 && Number(userAgent.match(/version\/([\d.]+)/)[1].split('.')[0]) < 12) {
            browserVersionFlag = true
          }
        }
      }
      return browserVersionFlag
    },
    isIE () { // ie?
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return true
      } else {
        return false
      }
    },
    isPC () {
      let userAgentInfo = navigator.userAgent
      let Agents = [
        'Android', 'iPhone',
        'SymbianOS', 'Windows Phone',
        'iPad', 'iPod'
      ]
      let flag = true
      for (let i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) !== -1) {
          flag = false
          break
        }
      }
      return flag
    },
    getTokenOrKey (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      let l = decodeURI(window.location.search)
      let r = l.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    // 因为通过环境变量拿到的url是个全路径，简单处理拿到 domain部分
    getDomain (url) {
      // 去掉 http，https
      // 去掉端口
      // 去掉/
      return url.replace(/(http|https):\/\//, '').split(':')[0].split('/')[0]
    },
    isMobileBrowser () {
      // 只有这个租户才有跳转企业微信功能
      if (CookieOperation.get('tenantId') !== '1791D358-7010-2455-9047-0D5521170F72') return false
      // 判断是否为移动端页面
      this.isMobile = !!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
      // 移动端打开不缩放页面
      const meta = document.getElementById('redcat-meta')
      meta && meta.parentNode.removeChild(meta)
    }
  },
  computed: {
    getStyle () {
      return this.isMobile ? {} : {'background-image': 'url(' + this.page.backgrounds + ')', 'background-size': 'cover'}
    }
  }
}

</script>

<style lang="scss">
  * {
    font-size:14px;
    padding: 0;
    margin: 0;
  }
  html,
  body {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;

    input::-webkit-input-placeholder {
      color: #a4a4a4;
    }
    input::-moz-placeholder {
      color: #a4a4a4;
    }
    input::-moz-placeholder {
      color: #a4a4a4;
    }
    input::-ms-input-placeholder {
      color: #a4a4a4;
    }
    /* 滚动条统一样式 */
    /*::-webkit-scrollbar {*/
    /*  width: 8px;*/
    /*  height: 8px;*/
    /*  background-color: #fff;*/
    /*}*/

    /*定义滚动条轨道 内阴影+圆角*/
    /*::-webkit-scrollbar-track {*/
    /*  border-radius: 10px;*/
    /*  background-color: #fff;*/
    /*}*/

    /*定义滑块 内阴影+圆角*/
    /*::-webkit-scrollbar-thumb {*/
    /*  border-radius: 10px;*/
    /*  background-color: #e2e2e2;*/
    /*}*/

    /*滑块效果*/
    /*::-webkit-scrollbar-thumb:hover {*/
    /*  border-radius: 5px;*/
    /*  background: #c8c8c8;*/
    /*}*/

    /*IE滚动条颜色*/
    /*scrollbar-face-color: #c8c8c8;*/
    /*!*滚动条颜色*!*/
    /*scrollbar-highlight-color: #fff;*/
    /*scrollbar-3dlight-color: #fff;*/
    /*scrollbar-darkshadow-color: #c8c8c8;*/
    /*scrollbar-shadow-color: #fff;*/
    /*!*滑块边色*!*/
    /*scrollbar-arrow-color: #c8c8c8;*/
    /*!*箭头颜色*!*/
    /*scrollbar-track-color: #fff;*/
  }

  .login-wrapper {
    position: relative;
    min-width: 500px;
    min-height: 500px;

    .app-down {
      position: absolute;
      right: 83px;
      top: 51px;
      text-align: right;
      display: inline-block;

      .app-down-content {
        color: #ACA9A9;
        position: relative;
        cursor: pointer;

        &:hover {
          color: var(--primary, #55ACF1);

          &::before {
            background: var(--primary, #55ACF1);
          }
        }

        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 1px;
          background: #ACA9A9;
          left: 0;
          bottom: -2px;
        }
      }
    }
    .app-external-link{
      @extend .app-down;
      top: 85px;
      a.app-down-content{
        text-decoration: none;
      }
    }

    .login-error {
      text-align: center;
      font-size: 16px;
      padding-top: 160px;

      a {
        font-size: 16px;
      }
    }

    .message {
      min-width: 322px;
      height: 12px;
      border-radius: 5px;
      background-color: #fef0f0;
      color: #F47A7A;
      border: 1px solid #fde2e2;
      position: fixed;
      left: 50%;
      top: 20px;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      animation:mymove .4s;
      padding: 15px 15px 15px 20px;
      display: flex;
      align-items: center;
      top: 20px;
      z-index: 2000;

      .message__content {
        font-size: 14px;
        margin-left: 10px;
        color: #f56c6c;
      }
      &.message_warning {
        background-color: #F47A7A;
        border-color: #F47A7A;
      }
    }
    @keyframes mymove{
      0%   {top:0px;opacity:0}
      100% {top:20px;opacity:1}}
  }
</style>
<style lang="scss" scoped>
  .login-wrapper {
    .versionMask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #e9eaeb;
      width: 100vw;
      height: 100vh;

      .box {
        position: absolute;
        left: 50%;
        top: 35%;
        transform: translate(-50%, -50%);

        .box-title {
          text-align: center;
          font-size: 20px;

          div {
            font-weight: 800;
            font-size: 20px;
            margin: 5px 0 30px 0;
          }
        }

        .prompt {
          width: 800px;
          min-height: 526px;
          background-color: #ffffff;
          border-radius: 5px;
          box-sizing: border-box;
          padding: 100px 94px;
          font-size: 12px;

          .recommended-download {
            padding-left: 3%;
            font-size: 20px;
            margin-top: 15px;
            margin-bottom: 25px;
            color: red;
          }

          .text {
            display: flex;

            div:nth-child(1) {
              width: 3%;
              padding-top: 2px;

              .el-icon-warning {
                color: red;
              }
            }

            div:nth-child(2) {
              width: 97%;
            }
          }

          .updateBrowser {
            font-size: 14px;
            line-height: 22px;

            a {
              text-decoration: none;
            }
          }

          .updateBrowserList {
            display: flex;
            align-items: center;
            justify-content: space-around;

            a {
              width: 180px;
              height: 240px;
              border: 1px solid #E4E6E9;
              border-radius: 4px;
              text-align: center;
              cursor: pointer;
              display: block;
              text-decoration: none;

              img {
                margin-top: 50px;
                margin-bottom: 50px;
                width: 80px;
                height: 80px;
                display: inline-block;
              }

              span {
                display: block;
                font-size: 16px;
                line-height: 24px;
                margin: 0 10px;
                border-top: 1px solid #e4e6e9;
                color: #000;
                text-decoration: none;
                padding-top: 16px;
              }
            }

            a:active, a:hover {
              border: 1px solid #0c4c7f;
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/system/login.vue